import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  homeDetail: {},
};

export default function home(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    default:
      result = state;
  }
  return result;
}
